// extracted by mini-css-extract-plugin
module.exports = {"sad-icon-wrapper":"dd31006766--sad-icon-wrapper--1wKCb","sad-icon":"dd31006766--sad-icon--3uqPr"};